import { GtmSdk } from "..";

const SERVER_MOCK = {
  push: () => {
    throw new Error("cannot call on server");
  },
};

export const CLIENT_MOCK = {
  push: () => {
    return undefined;
  },
};
export const createGtmInstance = (): GtmSdk => {
  return new GtmSdk(
    typeof window !== "undefined"
      ? (window?.dataLayer ?? CLIENT_MOCK)
      : SERVER_MOCK,
  );
};
